"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectDownListProps = void 0;

var _vue = require("vue");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _popover = _interopRequireDefault(require("ant-design-vue/lib/popover"));

var _collapse = _interopRequireWildcard(require("ant-design-vue/lib/collapse"));

require("ant-design-vue/lib/popover/style/index.css");

require("ant-design-vue/lib/collapse/style/index.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var selectDropDownListProps = {
  disabled: {
    type: Boolean,
    default: false
  },
  options: {
    type: Array
  },
  group: {
    type: Boolean,
    default: false
  },
  selectValue: {
    type: [String, Number]
  },
  placement: {
    type: String,
    default: 'top'
  },
  popoverStyle: {
    type: Object,
    default: {
      width: '200px',
      minHeight: '200px',
      height: '230px'
    }
  },
  theme: {
    type: String,
    default: 'button'
  },
  sameWidth: {
    type: Boolean,
    default: true
  },
  scaleKey: {
    type: String,
    default: 'slideScale'
  }
};
exports.SelectDownListProps = selectDropDownListProps;
var SelectDownList = (0, _vue.defineComponent)({
  name: 'SelectDownList',
  components: {
    Popover: _popover.default,
    Collapse: _collapse.default
  },
  props: selectDropDownListProps,
  emits: ['update:selectValue', 'selectChange'],
  setup: function setup(props, ctx) {
    var _this = this;

    var scaleKeyNum = (0, _vue.inject)(props.scaleKey);
    var scaleNumber = (0, _vue.computed)(function () {
      console.log('scaleNumber:', (scaleKeyNum === null || scaleKeyNum === void 0 ? void 0 : scaleKeyNum.value) || 1);
      return (scaleKeyNum === null || scaleKeyNum === void 0 ? void 0 : scaleKeyNum.value) || 1;
    }); //* 选中值

    var selectValue = (0, _vue.ref)(props.selectValue);
    var selectLabel = (0, _vue.computed)(function () {
      var _a;

      if (selectValue.value == undefined || selectValue.value === null) {
        return '';
      }

      return ((_a = props.options.find(function (option) {
        return option.value === (selectValue === null || selectValue === void 0 ? void 0 : selectValue.value);
      })) === null || _a === void 0 ? void 0 : _a.label) || '';
    });
    (0, _vue.watch)(function () {
      return props.selectValue;
    }, function (newVal) {
      selectValue.value = newVal;
    });
    (0, _vue.watch)(function () {
      return selectValue.value;
    }, function (newVal) {
      setActiveGroupKey(newVal);
      ctx.emit('update:selectValue', newVal);
    }); // * 分组

    var isGroup = (0, _vue.ref)(props.group);
    var avtiveGroupKey = (0, _vue.ref)('');
    (0, _vue.watch)(function () {
      return props.group;
    }, function (newVal) {
      isGroup.value = newVal;
    }); // * 分组信息

    var setActiveGroupKey = function setActiveGroupKey() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      var _a;

      if (!isGroup.value) {
        return;
      }

      avtiveGroupKey.value = ((_a = props.options.find(function (op) {
        return op.value === (val || selectValue.value);
      })) === null || _a === void 0 ? void 0 : _a.group) || '';
    };

    var selectOptions = (0, _vue.computed)(function () {
      if (!isGroup.value) {
        return props.options || [];
      }

      var group = _lodash.default.groupBy(props.options || [], 'group');

      var groupOptions = {};
      Object.keys(group).reduce(function (previousValue, currentValue) {
        var key = currentValue;

        if (key === undefined || key === 'undefined') {
          key = '默认';
        }

        previousValue[key] = group[currentValue];
        return previousValue;
      }, groupOptions);
      return groupOptions;
    }); // * 显示

    var selectListVisible = (0, _vue.ref)(false);

    var onSelectBtnClick = function onSelectBtnClick() {
      if (props.disabled) {
        return;
      }

      selectListVisible.value = !selectListVisible.value;
    };

    var contentRef = (0, _vue.ref)();

    var onVisibleChange = function onVisibleChange(visible) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var selectItem, contentHeight, itemTop;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!visible) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return (0, _vue.nextTick)();

              case 3:
                selectItem = contentRef.value.querySelector('.select-down-list_selected');

                if (selectItem) {
                  contentHeight = contentRef.value.offsetHeight;
                  itemTop = selectItem.offsetTop;
                  contentRef.value.scrollTo(0, itemTop - contentHeight / 2);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }; // *  选中


    var onSelectChange = function onSelectChange(_selectValue) {
      selectValue.value = _selectValue;
      selectListVisible.value = false;
      ctx.emit('selectChange', selectValue.value);
    }; // * 计算下拉框位置


    var selectBtnRef = (0, _vue.ref)();
    var popupStyle = (0, _vue.reactive)((0, _extends2.default)({}, props.popoverStyle));
    var popupItemStyle = (0, _vue.computed)(function () {
      return {
        margin: "".concat(2 * scaleNumber.value, "px 0"),
        height: "".concat(42 * scaleNumber.value, "px"),
        borderRadius: "".concat(7 * scaleNumber.value, "px"),
        fontSize: "".concat(20 * scaleNumber.value, "px")
      };
    });
    var collapseItemStyle = (0, _vue.computed)(function () {
      return {
        margin: "".concat(2 * scaleNumber.value, "px 0"),
        padding: "".concat(5 * scaleNumber.value, "px"),
        borderRadius: "".concat(7 * scaleNumber.value, "px"),
        fontSize: "".concat(20 * scaleNumber.value, "px")
      };
    });
    var collapseHeaderStyle = (0, _vue.computed)(function () {
      return "font-size:".concat(20 * scaleNumber.value, "px;padding:").concat(12 * scaleNumber.value, "px ").concat(40 * scaleNumber.value, "px ").concat(12 * scaleNumber.value, "px ").concat(16 * scaleNumber.value, "px;lineHeight:").concat(22 * scaleNumber.value, "px");
    });

    var computedPopupPosition = function computedPopupPosition() {
      if (scaleNumber.value !== 1) {
        var originWidth = parseInt(props.popoverStyle.width);
        var originHeight = parseInt(props.popoverStyle.height);
        var originMinHeight = parseInt(props.popoverStyle.minHeight);
        popupStyle.width = "".concat(originWidth * scaleNumber.value, "px");
        popupStyle.height = "".concat(originHeight * scaleNumber.value + 2, "px");
        popupStyle.minHeight = "".concat(originMinHeight * scaleNumber.value, "px");
      }

      if (props.sameWidth) {
        popupStyle.width = "".concat(selectBtnRef.value.offsetWidth * scaleNumber.value, "px");
      }
    };

    (0, _vue.watchEffect)(function () {
      if (selectListVisible.value) {
        setTimeout(computedPopupPosition, 0);
        onVisibleChange(selectListVisible.value);
      }
    }); // * 主题

    var themeClassMap = {
      button: 'select-down-list-btn',
      select: 'select-down-list-select'
    };
    var themeClass = (0, _vue.computed)(function () {
      return themeClassMap[props.theme];
    });
    var collapseRef = (0, _vue.ref)();
    (0, _vue.watch)(function () {
      return collapseRef.value;
    }, function () {
      var _a, _b;

      var headerEls = ((_b = (_a = collapseRef.value) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.getElementsByClassName('select-down-list-popup-content-collapse-header')) || [];

      for (var i = 0; i < headerEls.length; i++) {
        headerEls[i].style = collapseHeaderStyle.value;
      }
    });
    (0, _vue.onMounted)(function () {
      setActiveGroupKey();
    });
    return {
      scaleNumber: scaleNumber,
      selectValue: selectValue,
      selectLabel: selectLabel,
      isGroup: isGroup,
      avtiveGroupKey: avtiveGroupKey,
      selectOptions: selectOptions,
      selectListVisible: selectListVisible,
      selectBtnRef: selectBtnRef,
      popupStyle: popupStyle,
      popupItemStyle: popupItemStyle,
      collapseItemStyle: collapseItemStyle,
      collapseHeaderStyle: collapseHeaderStyle,
      themeClass: themeClass,
      contentRef: contentRef,
      collapseRef: collapseRef,
      onSelectBtnClick: onSelectBtnClick,
      onSelectChange: onSelectChange,
      onVisibleChange: onVisibleChange
    };
  },
  render: function render() {
    var _this2 = this;

    var optionsRender = function optionsRender() {
      return _this2.selectOptions.map(function (option) {
        return (0, _vue.createVNode)("div", {
          "class": ['select-down-list-popup-item', _this2.selectValue === option.value ? ['select-down-list-popup-item-selected', 'select-down-list_selected'] : ''],
          "data-value": option.value,
          "onClick": function onClick() {
            return _this2.onSelectChange(option.value);
          },
          "style": _this2.popupItemStyle
        }, [option.label]);
      });
    };

    var groupOptionsRender = function groupOptionsRender() {
      return (0, _vue.createVNode)(_collapse.default, {
        "class": "select-down-list-popup-content-collapse",
        "activeKey": _this2.avtiveGroupKey,
        "onUpdate:activeKey": function onUpdateActiveKey($event) {
          return _this2.avtiveGroupKey = $event;
        },
        "accordion": true,
        "expandIconPosition": "right",
        "ref": "collapseRef"
      }, {
        default: function _default() {
          return [Object.keys(_this2.selectOptions).map(function (key) {
            return (0, _vue.createVNode)(_collapse.CollapsePanel, {
              "key": key,
              "header": key,
              "headerClass": "select-down-list-popup-content-collapse-header"
            }, {
              default: function _default() {
                return [_this2.selectOptions[key].map(function (option) {
                  return (0, _vue.createVNode)("div", {
                    "class": ['select-down-list-popup-content-collapse-item', _this2.selectValue === option.value ? ['select-down-list-popup-content-collapse-item-selected', 'select-down-list_selected'] : ''],
                    "style": _this2.collapseItemStyle,
                    "data-value": option.value,
                    "onClick": function onClick() {
                      return _this2.onSelectChange(option.value);
                    }
                  }, [(0, _vue.createVNode)("div", {
                    "class": "select-down-list-sound-font-content"
                  }, [(0, _vue.createVNode)("div", {
                    "class": 'select-down-list-sound-font-content-name'
                  }, [option.label]), option.name && (0, _vue.createVNode)("div", {
                    "class": ['select-down-list-sound-font-content-image', "sound-font-".concat(option.name)],
                    "style": "width:".concat(31 * (_this2.scaleNumber || 1), "px;height:").concat(30 * (_this2.scaleNumber || 1), "px")
                  }, null)])]);
                })];
              }
            });
          })];
        }
      });
    };

    var slots = {
      content: function content() {
        return (0, _vue.createVNode)("div", {
          "class": "select-down-list-popup-content",
          "ref": "contentRef",
          "style": _this2.popupStyle
        }, [_this2.isGroup ? groupOptionsRender() : optionsRender()]);
      }
    };
    return (0, _vue.createVNode)(_popover.default, {
      "visible": _this2.selectListVisible,
      "onUpdate:visible": function onUpdateVisible($event) {
        return _this2.selectListVisible = $event;
      },
      "placement": this.placement,
      "trigger": "click",
      "overlayClassName": this.disabled ? 'select-down-list-popup-none' : 'select-down-list-popup',
      "overlayStyle": this.popupStyle,
      "autoAdjustOverflow": false,
      "transitionName": '',
      "destroyTooltipOnHide": true
    }, (0, _objectSpread2.default)({
      default: function _default() {
        return [(0, _vue.createVNode)("div", {
          "class": "select-down-list",
          "onClick": _this2.onSelectBtnClick
        }, [(0, _vue.createVNode)("div", {
          "class": [_this2.themeClass, _this2.disabled ? "".concat(_this2.themeClass, "-disabled") : ''],
          "ref": "selectBtnRef"
        }, [(0, _vue.createVNode)("div", {
          "class": "".concat(_this2.themeClass, "-label")
        }, [_this2.selectLabel]), (0, _vue.createVNode)("div", {
          "class": ["".concat(_this2.themeClass, "-suffixIcon"), _this2.selectListVisible && !_this2.disabled ? "".concat(_this2.themeClass, "-suffixIcon-open") : '']
        }, null)])])];
      }
    }, slots));
  }
});

SelectDownList.install = function (app) {
  app.component(SelectDownList.name, SelectDownList);
  return app;
};

var _default2 = SelectDownList;
exports.default = _default2;